/**
 * Взаиморасчёты психолога (кабинет)
 */
var PsyBilling = {

	init: function() {
		var container = document.querySelector('[data-psy-billing-module-id]');
		if (!container) return;
		this.mid = container.getAttribute('data-psy-billing-module-id');
	},

	openDetail: function(actId) {
		var popup = document.getElementById('popup-billing-detail');
		var content = document.getElementById('popup-billing-detail-content');
		content.innerHTML = '<div class="loading">Загрузка...</div>';
		popup.classList.add('active');

		fetch('/ajax.php?mid=' + this.mid + '&action=get_act_detail&act_id=' + actId)
			.then(function(r) { return r.text(); })
			.then(function(html) {
				content.innerHTML = html;
			});
	},

	closeDetail: function() {
		document.getElementById('popup-billing-detail').classList.remove('active');
	},

	confirmAct: function(actId) {
		if (!confirm('Вы подтверждаете акт взаиморасчётов?')) return;
		fetch('/ajax.php?mid=' + this.mid + '&action=confirm_act', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: 'act_id=' + actId
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				alert(res.message || 'Акт подтверждён');
				location.reload();
			} else {
				alert(res.error || 'Ошибка');
			}
		});
	},

	uploadReceipt: function(actId, input) {
		if (!input.files || !input.files[0]) return;

		var formData = new FormData();
		formData.append('act_id', actId);
		formData.append('receipt', input.files[0]);

		fetch('/ajax.php?mid=' + this.mid + '&action=upload_receipt', {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				alert(res.message || 'Чек загружен');
				location.reload();
			} else {
				alert(res.error || 'Ошибка');
			}
		});
	}
};

$(document).ready(function() {
	PsyBilling.init();
});

window.PsyBilling = PsyBilling;
